import React from "react";
import {ProjectBanner} from './banner'
import {SkeletonLoading} from './loader'
import{lists} from './dummy'
import { ProjectItem } from "./item";
 
export const ListView = () => {
    const loader = React.useRef(null);

    return (
        <React.Fragment>
            <div className="list_view" style={{ minHeight: '10vh' }}>
                <List />
                <div ref={loader} />
            </div>
        </React.Fragment>
    )
}

export default ListView

export const List = () => {
    return (
        <ul>
            <SkeletonLoading />
            {lists.map((item, i) => {
                let index = i===0?1:i; 
                if(index%5===0) return <React.Fragment>
                    <ProjectBanner />
                    <ProjectItem key={'lv-' + i} item={item} />
                </React.Fragment>

                return  <ProjectItem key={'list-view-' + i} item={item} />
            })}

        </ul>
    )
}


